import { makeRequest } from "../../services/restcall";
import { ApiResponse } from "../../services/types";
import HttpMethod from '../../services/httpMethods'


///api/personalrecord/allorderattention?startDate=2025-06-09&endDate=2025-06-10
export async function postRegisterOrderAttentionAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/servicerecord/orderattention',value)
}

export async function postMedicalRecordOrderAttentionAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/medicalrecord/orderattention', value)
}

export async function postOrderAttentionAppointmentAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/medicalrecord/orderattention/appointment', value)
}

export async function getPaymentmethodsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/servicerecord/all-paymentmethods', {})
}
export async function putIdentityOrderStatusAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/servicerecord/orderattention/status',value)
}

export async function getIdentityAllOrderAtentionAPI(start:string,end:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/servicerecord/allorderattention?startDate='+ start +'&endDate='+end,{})
}

export async function postMedicalRecordObservationAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/medicalRecord/observation',value)
}

export async function getPaymentAPI(orderAttentionCode:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/payments?orderAttentionCode='+orderAttentionCode,{})
}

export async function postPaymentAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/payments',value)
}
export async function getDepositAPI(dni:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/deposit?dni='+dni,{})
}

export async function postDepositAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/deposit',value)
}

export async function putProcedureTreatmentPlanStatusAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/personalrecord/treatmentPlan/TreatmentEvidence/Status',value)
}

export async function putProcedurePerToothTreatmentPlanStatusAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/personalrecord/treatmentPlan/procedurePerTooth/TreatmentEvidence/Status',value)
}

export async function getprocedurePerToothAPI(treatmentPlanId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/treatmentPlan/procedurePerTooth?treatmentPlanId='+ treatmentPlanId,{})
}

export async function getTreatmentPlanAPI(dni:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/treatmentPlan?dni='+ dni,{})
}

export async function postProcedurePerToothAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/treatmentPlan/procedurePerTooth',value)
}

export async function postTreatmentPeerToothAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/treatmentPlan/procedurePerTooth/TreatmentEvidence',value)
}

export async function deleteGeneralEvidenceTreatmentPerToothAPI(medicalRecordId:string, evidenceTreatmentId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/personalrecord/treatmentPlan/generalTreatmentEvidence?treatmentPlanId='+medicalRecordId +'&evidenceTreatmentId='+evidenceTreatmentId, {})
}

export async function postGeneralTreatmentEvidenceAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/treatmentPlan/generalTreatmentEvidence',value)
}

export async function postTreatmentPlanAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/treatmentPlan',value)
}

export async function deleteEvidenceTreatmentPerToothAPI(treatmentPlanId:string, number:number, evidenceTreatmentId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/personalrecord/treatmentPlan/procedurePerTooth/TreatmentEvidence?treatmentPlanId='+treatmentPlanId +'&number='+number+'&evidenceTreatmentId='+evidenceTreatmentId, {})
}

export async function getPathologicalHistorybyPersonalIdAPI(personalId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/medical-history?personalId='+ personalId,{})
}

export async function putPathologicalHistoryAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/personalrecord/medical-history',value)
}

export async function postPathologicalHistoryAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/medical-history',value)
}

export async function getProceduresPerToothAPI(treatmentPlanId:string, number:number, position?:string): Promise<ApiResponse> {
    let url = '/api/personalrecord/treatmentPlan/procedurePerTooth?treatmentPlanId='+ treatmentPlanId+'&number='+number;
    if (position) {
        url += '&position=' + position;
    }
    return await makeRequest(HttpMethod.GET, url, {});
}

export async function getMedicalRecordbyOrderAtentionAPI(OrderAttentionCode:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/medicalRecord?orderAttentionCode='+ OrderAttentionCode,{})
}

export async function postMedicalRecordAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/medicalRecord',value)
}

export async function postProcedurePeerToothAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/medicalRecord',value)
}

/*export async function postProcedurePerToothAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/procedurePerTooth',value)
}*/

export async function postEvidencePerToothAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/treatmentPlan/procedurePerTooth/TreatmentEvidence',value)
}


export async function postThearthmenPeerToothAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/treatmentPlan/procedurePerTooth/TreatmentEvidence',value)
}



export async function getAllOrderAtentionAPI(start:string,end:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/allorderattention?startDate='+ start +'&endDate='+end,{})
}

export async function getMedicalRecordOrganizationOrderAttentionsAPI(start: string, end: string, organizationId?: string | null): Promise<ApiResponse> {
    const organizationQuery = organizationId ? '&organizationId=' + encodeURIComponent(organizationId) : '';
    return await makeRequest(HttpMethod.GET, '/api/medicalrecord/orderattention/medic?dni=&startDate=' + encodeURIComponent(start) + '&endDate=' + encodeURIComponent(end) + organizationQuery, {});
}

export async function getAllOrderAtentionWithStatusAPI(start:string,end:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/allorderattention/status?startDate='+ start +'&endDate='+end,{})
}

export async function getAllCommissionsServicesAPI(start:string,end:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/servicerecord/commission?startDate='+ start +'&endDate='+end,{})
}

export async function getAllCommissionsAPI(start:string,end:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/commission?startDate='+ start +'&endDate='+end,{})
}
export async function putOrderStatusAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/personalrecord/orderattention/status',value)
}

export async function postUploadfilesAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/uploadfiles',value)
}

export async function putLaboratoryProviderOrderAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/personalrecord/laboratoryproviderorder',value)
}

export async function getResultsLabAPI(personalRecordId:string,orderAttentionId:string,sendEmail:boolean): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/laboratoryresults?personalRecordId='+personalRecordId+'&orderAttentionId='+orderAttentionId+'&sendResults='+sendEmail,{})
}

export async function getMedicalOrderResultsByDniAPI(dni:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/medicalrecord/medicalorder/result?dni='+encodeURIComponent(dni),{})
}

export async function postMedicalOrderResultAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/medicalrecord/medicalorder/result',value)
}

export async function getMedicalDoctorAttentionAPI(doctorId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/medicalrecord/doctor/attention?doctorId='+encodeURIComponent(doctorId),{})
}

export async function getOrderAttentionInformationServiceAPI(dni:string,orderId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/servicerecord/order-attention-info?dni='+dni+'&orderAttentionId='+orderId,{})
}

export async function getInformationServiceAPI(dni:string,orderId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/orderattentioninfo?dni='+dni+'&orderAttentionId='+orderId,{})
}

export async function getServiceRecordOrderResultsAPI(orderAttentionId:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/servicerecord/order-results?orderAttentionId='+orderAttentionId,{})
}

export async function postServiceRecordResultsAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/servicerecord/results',value)
}

export async function putServiceRecordResultsAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/servicerecord/update-results',value)
}

export async function getOrderTableAPI(dni:string,startDate:string,endDate:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/orderattention?id='+dni+'&startDate='+startDate+'&endDate='+endDate,{})
}

export async function postRegisterLaboratoryAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/orderattention',value)
}


export async function getAllPersonalRecordContainsNameOrDniAPI(dni?: string, name?: string): Promise<ApiResponse> {
    let url = '/api/personalrecord';
    if (dni) url += `?dni=${dni}&`;
    if (name) url += `?name=${encodeURIComponent(name)}&`;
    url = url.endsWith('&') ? url.slice(0, -1) : url;
    return await makeRequest(HttpMethod.GET, url, {});
}

// Endpoints already exposed by MS Personal Record for the administration screen.
export async function getAllPersonalRecordsAPI(organizationId?: string | null): Promise<ApiResponse> {
    const query = organizationId ? '?organizationId=' + encodeURIComponent(organizationId) : '';
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/all' + query, {});
}

export async function getPersonalRecordInformationAPI(dni: string, organizationId?: string | null): Promise<ApiResponse> {
    const query = '?dni=' + encodeURIComponent(dni) + (organizationId ? '&organizationId=' + encodeURIComponent(organizationId) : '');
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/information' + query, {});
}

export async function getPersonalRecordMedicalInformationAPI(dni: string, organizationId?: string | null): Promise<ApiResponse> {
    const query = '?dni=' + encodeURIComponent(dni) + (organizationId ? '&organizationId=' + encodeURIComponent(organizationId) : '');
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/medicalInformation' + query, {});
}

export async function postPersonalRecordPatientAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/patient', value);
}

export async function deletePersonalRecordAPI(dni: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/personalrecord?dni=' + encodeURIComponent(dni), {});
}

export async function getAllIdentityPersonalRecordContainsNameOrDniAPI(dni: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/personalrecord?dni='+dni, {});
}

export async function postIdentityPersonalRecordAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/personalrecord',value)
}
export async function putIdentityPersonalRecordAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/personalrecord',value)
}

export async function putIdentityPersonalRecordStatusAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/personalrecord/status',value)
}

export async function postRegistePersonalRecordAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord',value)
}
export async function putPersonalRecordAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/personalrecord',value)
}
export async function putPersonalRecordStatusAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/personalrecord/status',value)
}

export async function getAddressByPersonalRecordAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/address?personalId='+value,{})
}
export async function postAddressAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/address',value)
}


export async function getAllEmailAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/personalrecord/email?personalId='+value,{})
}
export async function postEmailAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/personalrecord/email',value)
}
export async function putEmailAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/personalrecord/email',value)
}
